module.exports = require('./Switch');


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/www/alipay-cd/project/antd-pro/antd-pro/scaffold/node_modules/_rc-switch@1.5.3@rc-switch/es/index.js
// module id = 381
// module chunks = 0